import React from 'react';
import { useStyles } from '../styles';
import { ReactComponent as GreenCheckmark } from 'assets/icons/GreenCheckmark.svg';
import { ReactComponent as BlueCheckmark } from 'assets/icons/BlueCheckmark.svg';

interface IMobileNavigationStepProps {
  step: {
    title: string;
    isCompleted?: boolean;
    isClickable?: boolean;
    disabled?: boolean;
    fields?: {
      name: string;
      id: string;
      isRequired?: boolean;
      isCompleted?: boolean;
      isSkippable?: boolean;
      skippableTill?: number;
    }[];
    icon: React.ReactNode;
  };
  title: string;
  isActive: boolean;
  isCompleted?: boolean;
  isDisabled: boolean;
  isLastStep: boolean;
  onClick: () => void;
}

const MobileNavigationStep: React.FC<IMobileNavigationStepProps> = ({
  step,
  title,
  isActive,
  isCompleted,
  isDisabled,
  isLastStep,
  onClick,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.mobileStepWithConnector}>
      <div
        className={`${classes.mobileNavigationStep} ${
          isActive ? classes.mobileNavigationStepActive : classes.mobileNavigationStepInactive
        } ${isDisabled ? classes.mobileNavigationStepDisabled : ''}`}
        onClick={onClick}
      >
        <div className={classes.mobileStepIconContainer}>
          {isActive ? <BlueCheckmark /> : isCompleted ? <GreenCheckmark /> : <RegularDot />}
        </div>
        <div className={classes.mobileStepTitleContainer}>
          <p
            className={`${classes.mobileStepTitle} ${step.isCompleted && !isActive ? classes.stepTitleCompleted : ''} ${isActive ? classes.mobileStepTitleActive : ''}`}
          >
            {title}
          </p>
        </div>
      </div>
      {/* Connecting line - don't show after the last step */}
      {!isLastStep && <div className={classes.mobileStepConnector} />}
    </div>
  );
};

export const FilledDot = () => {
  const classes = useStyles();
  return (
    <div className={classes.mobileStepIconCircle}>
      <div className={classes.mobileStepIconDot} />
    </div>
  );
};

export const RegularDot = () => {
  const classes = useStyles();
  return (
    <div className={classes.regularStepWrapper}>
      <div className={classes.regularMobileStepIconDot} />
    </div>
  );
};

export default MobileNavigationStep;
